import { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [rfc, setRfc] = useState("");
  const [idRegistro, setIdRegistro] = useState(null);
  const [email, setEmail] = useState("");
  const [tacAccepted, setTacAccepted] = useState(false);
  const [buroAuthorized, setBuroAuthorized] = useState(false);

  // Función para limpiar todos los estados al cerrar sesión
  const clearAuth = () => {
    setRfc("");
    setIdRegistro(null);
    setEmail("");
    setTacAccepted(false);
    setBuroAuthorized(false);
  };

  return (
    <AuthContext.Provider
      value={{
        rfc,
        setRfc,
        idRegistro,
        setIdRegistro,
        email,
        setEmail,
        tacAccepted,
        setTacAccepted,
        buroAuthorized,
        setBuroAuthorized,
        clearAuth,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
